var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-container"},[_c('NavBar'),_c('PageMain'),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }